/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Paint_OnInputs */



/**
* | output |
* | --- |
* | "Paint-On" |
*
* @param {Input_Caption_Style_Paint_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_paint_on = /** @type {((inputs?: Input_Caption_Style_Paint_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Paint_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paint-On")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufmalen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dipingere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Наносить краской")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pintar sobre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("涂漆")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ペイントオン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर पैंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pintar")
	return /** @type {LocalizedString} */ ("Paint-On")
});